import { createSelector } from '@ngrx/store';

import { HomePolicy } from '@models/swagger';
import { State } from './reducer';
import { selectPutPolicyState } from '../selectors';

export const getData = createSelector(selectPutPolicyState, (state: State) => state.data);

export const getError = createSelector(selectPutPolicyState, (state: State) => state.error);

export const getLoading = createSelector(selectPutPolicyState, (state: State) => state.loading);

export const mapData = <T>(fn: (data: HomePolicy) => T) =>
  createSelector(selectPutPolicyState, (state: State) => fn(state.data));
